import { useQuery } from 'react-query';
import { useToastError } from 'lib/hooks/useToastError';
import { metricsKeys } from './metricsKeys';
import { TopVideosCtasParams } from './queryTopCta';
import { EXPRESS_API } from 'configs/api/expressApi';
import { IVIdeoDelivery } from '../reportsApi';
import { REPORTS_STALE_TIME } from 'app/pages/reports/dashboard/main/widgets/types';

export type MostViewedVideosResponseData = {
  videoId: number;
  title: string;
  cnt: string;
};

export const getMyTeamStats = async (params: any): Promise<IVIdeoDelivery> => {
  const response = await EXPRESS_API.get('/metrics/widget/my-team-stats', {
    params,
  });

  return response.data;
};

export const useQueryMyTeamStats = ({
  params,
  enabled,
}: {
  params: TopVideosCtasParams;
  enabled: boolean;
}) => {
  const { showError } = useToastError();

  return useQuery(
    metricsKeys.myTeamStats(params),
    () => getMyTeamStats({ ...params, users: 'all' }),
    {
      onError: showError,
      refetchOnMount: true,
      staleTime: REPORTS_STALE_TIME,
      enabled,
    }
  );
};
